export const customerTransportOffers = (state: any) => state?.customerTransport?.offers;
export const customerTransportDetails = (state: any) => state?.customerTransport?.details;
